import { Incoterms } from 'api';
import { yup } from 'form';

export const buyPriceCalculatorSchema = yup.object().shape({
  buyer_id: yup.number().required(),
  buyer_incoterm: yup.string().oneOf(Object.values(Incoterms)).required(),
  buyer_site_id: yup.number().notRequired(),
  destination_site_id: yup.number().notRequired(),
  material_grade_id: yup.number().notRequired(),
  material_spec_id: yup.number().notRequired(),
  port_of_discharge_id: yup.number().notRequired(),
  target_margin: yup.string().required(),
  tonnes: yup.string().notRequired(),
});

export const sellPriceCalculatorSchema = yup.object().shape({
  material_grade_id: yup.number().notRequired(),
  material_spec_id: yup.number().notRequired(),
  origin_site_id: yup.number().notRequired(),
  port_of_loading_id: yup.number().notRequired(),
  seller_id: yup.number().required(),
  seller_incoterm: yup.string().oneOf(Object.values(Incoterms)).required(),
  seller_site_id: yup.number().notRequired(),
  target_margin: yup.string().required(),
  tonnes: yup.string().notRequired(),
});
